export default __webpack_public_path__ + "static/media/IPad_3.d44de64b.png";